import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDebouncedCallback } from 'use-debounce';
import LayoutProvider from '../../Contexts/LayoutProvider';
import { getParamsAr } from '../../features/CustomInput/SelectWithCheck';
import LibModal from '../../features/LibModal/LibModal';
import PageTitle from '../../utils/PageTitle';
import { mkRelativeUrl } from '../../utils/URL';
import AddIssueTicketModal from '../SupportTicket/Modals/AddIssueTicketModal';
import SubscriptionPageHeaderMobile from './Components/SubscriptionPageHeaderMobile';
import SubscriptionPageTableMobile from './Components/SubscriptionPageTableMobile';
import SubscriptionsPageHeader from './Components/SubscriptionsPageHeader';
import SubscriptionsPageTable from './Components/SubscriptionsPageTable';
import SubscriptionsProvider, { useSubscriptions } from './SubscriptionsProvider';

function PageCont() {
    const initialState = {
        user: 0,
        subscription: 0
    };
    const [dataId, setDataId] = useState(initialState);

    // Search Params
    const [searchParams] = useSearchParams();
    const [queryStr, setQueryStr] = useState({ q: searchParams.get('q') || '' });
    const { handleReload, subscriptionsData, setParams } = useSubscriptions();
    const navigate = useNavigate();

    const p = useMemo(
        () => ({
            q: searchParams.get('q') || '',
            applications: getParamsAr(searchParams.get('applications')),
            'limit-by': searchParams.get('limit-by') || '',
            status: searchParams.get('status') || '',
            'order-by': searchParams.get('order-by'),
            sort: searchParams.get('sort'),
            page: searchParams.get('page')
        }),
        [searchParams]
    );

    const debounceUpdate = useDebouncedCallback((val) => {
        navigate(mkRelativeUrl('/subscriptions/manage', { ...p, q: val }));
    }, 400);

    const handleChangeFilterData = (e) => {
        const { name, value } = e.target;
        if (name) {
            if (name === 'q') {
                setQueryStr({ q: value });
                debounceUpdate(value);
            } else {
                navigate(mkRelativeUrl('/subscriptions/manage', { ...p, [name]: value }));
            }
        }
    };

    const onChangePage = (page) => {
        navigate(mkRelativeUrl('/subscriptions/manage', { ...p, page }));
    };

    const handleSortingData = (column) => {
        navigate(
            mkRelativeUrl('/subscriptions/manage', {
                ...p,
                'order-by': column,
                sort: p.sort === 'desc' ? 'asc' : 'desc'
            })
        );
    };
    const handleResetFilter = () => {
        navigate(mkRelativeUrl('/subscriptions/manage', {}));
    };

    const handleCreateSupportTicket = (ev, userId, subscriptionId) => {
        ev.stopPropagation();
        ev.preventDefault();
        setDataId({
            user: userId,
            subscription: subscriptionId
        });
    };

    const closeModal = () => {
        setDataId(initialState);
    };

    useEffect(() => {
        setParams(p);
    }, [p, setParams]);

    return (
        <div className="subscriptions_page inner_page_cont">
            <LayoutProvider>
                <SubscriptionsPageHeader
                    p={{ ...p, ...queryStr }}
                    filterHandler={handleChangeFilterData}
                    handleReload={handleReload}
                    queryStr={queryStr}
                    layout="default"
                />
                <SubscriptionPageHeaderMobile
                    p={{ ...p, ...queryStr }}
                    onChangeHandler={handleChangeFilterData}
                    onResetFilter={handleResetFilter}
                    handleReload={handleReload}
                    layout={['md', 'sm', 'xs', 'xxs']}
                />
            </LayoutProvider>
            <LayoutProvider>
                <SubscriptionsPageTable
                    layout="default"
                    data={subscriptionsData}
                    sortBy={p.sort}
                    sortedColumn={p['order-by']}
                    sortedHandler={handleSortingData}
                    onChangePage={onChangePage}
                    handleCreateSupportTicket={handleCreateSupportTicket}
                />
                <SubscriptionPageTableMobile
                    layout={['md', 'sm', 'xs', 'xxs']}
                    data={subscriptionsData}
                    handleCreateSupportTicket={handleCreateSupportTicket}
                />
            </LayoutProvider>

            {dataId.user && dataId.subscription ? (
                <LibModal title="Add Issue Ticket" setOpen={closeModal}>
                    <AddIssueTicketModal
                        userId={dataId.user}
                        ssId={dataId.subscription}
                        type="subscription"
                        closeModal={() => closeModal()}
                        handleReload={() => null}
                    />
                </LibModal>
            ) : null}
        </div>
    );
}
function SubscriptionsPage() {
    // set page title
    PageTitle(`Subscriptions`);

    return (
        <SubscriptionsProvider>
            <PageCont />
        </SubscriptionsProvider>
    );
}
export default SubscriptionsPage;
